module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section content-padded"
  }, [(_vm.currentType === 0) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.templateList), function(item) {
    return _c('el-col', {
      key: item.index,
      attrs: {
        "xs": 12,
        "sm": 12,
        "md": 8,
        "lg": 6,
        "xl": 4
      }
    }, [_c('div', {
      staticClass: "template-item"
    }, [_c('div', {
      staticClass: "template-wrap"
    }, [_c('div', {
      staticClass: "template-img"
    }, [(item.template_name === 'yykmendian') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykmembership') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_01.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykcutdown') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_02.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykweishop') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_04.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykcommunity') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_07.jpg"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.template_name === 'yykcommunitypms') ? _c('img', {
      attrs: {
        "src": require("../../../static/img/template_img_06.jpg"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "template-caption"
    }, [_c('div', {
      staticClass: "template-title"
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "content-padded"
    }, [(item.is_open) ? _c('el-button', {
      staticClass: "template-opend-btn",
      attrs: {
        "type": "default",
        "disabled": ""
      }
    }, [_vm._v("已开通")]) : _c('el-button', {
      staticClass: "template-opend-btn",
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.openTemp(item.template_name)
        }
      }
    }, [_vm._v("免费开通")])], 1)])])])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.currentType === 1) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentType === 2) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-14007a08", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14007a08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/template.vue
// module id = 2487
// module chunks = 0